module.exports = __webpack_public_path__ + "static/media/photoonwood.56d7cfa0.png";